import React from 'react';
import { useSelector } from 'react-redux';
import { useWindowSize } from '@yme/hooks/index';
import { getRootLang } from '@yme/selectors/common';
import { useTranslation } from '@yme/services/i18n';
import { SearchCategoryTypes } from '@yme/utils/bloomreach';
import { AccessoryApparelGrid, ModelsGrid, ContentGridWrapper } from '../components/grids';
import { mergeTabsData } from './helpers';
export const useSearchPageTabs = ({ primaryFacets, contentData: { other, destinations, news, event }, productData: { unit, accessory, apparel }, isRightToLeft, query, wrapperWidth, autoCorrectQueryResult, getProductData, getContentData, }) => {
    const { t } = useTranslation();
    const { isInfiniteDesktopView, isMobileView } = useWindowSize();
    const language = useSelector(getRootLang);
    let parsedCategoryType = {};
    try {
        parsedCategoryType = JSON.parse(t('globalSearch_primaryTypeCategory_map'));
    }
    catch (error) { }
    const commonContentProps = {
        isRightToLeft,
        language,
        query,
        wrapperWidth,
        autoCorrectQueryResult,
        getContentData,
    };
    const tabsData = [
        {
            entityId: 1,
            tabContent: (React.createElement(ModelsGrid, { isInfiniteDesktopView: isInfiniteDesktopView, isMobileView: isMobileView, isRightToLeft: isRightToLeft, isLoaded: unit.isLoaded, productItems: unit.docs, modelsFacets: unit.facets, numFound: unit.numFound, query: query, category: SearchCategoryTypes.UNIT, getProductData: getProductData })),
            type: SearchCategoryTypes.UNIT,
        },
        {
            entityId: 2,
            tabContent: (React.createElement(AccessoryApparelGrid, { isRightToLeft: isRightToLeft, isMobileView: isMobileView, isInfiniteDesktopView: isInfiniteDesktopView, isLoaded: accessory.isLoaded, productItems: accessory.docs, numFound: accessory.numFound, facets: accessory.facets, query: query, category: SearchCategoryTypes.ACCESSORY, getProductData: getProductData })),
            type: SearchCategoryTypes.ACCESSORY,
        },
        {
            entityId: 3,
            tabContent: (React.createElement(AccessoryApparelGrid, { isRightToLeft: isRightToLeft, isMobileView: isMobileView, isInfiniteDesktopView: isInfiniteDesktopView, isLoaded: apparel.isLoaded, productItems: apparel.docs, numFound: apparel.numFound, query: query, category: SearchCategoryTypes.APPAREL, facets: apparel.facets, getProductData: getProductData })),
            type: SearchCategoryTypes.APPAREL,
        },
        {
            entityId: 4,
            tabContent: (React.createElement(ContentGridWrapper, { ...commonContentProps, contentItems: news.docs, numFound: news.numFound, isLoaded: news.isLoaded, category: SearchCategoryTypes.NEWS })),
            type: SearchCategoryTypes.NEWS,
        },
        {
            entityId: 5,
            tabContent: (React.createElement(ContentGridWrapper, { ...commonContentProps, contentItems: event.docs, numFound: event.numFound, isLoaded: event.isLoaded, category: SearchCategoryTypes.EVENTS })),
            type: SearchCategoryTypes.EVENTS,
        },
        {
            entityId: 6,
            tabContent: (React.createElement(ContentGridWrapper, { ...commonContentProps, contentItems: destinations.docs, numFound: destinations.numFound, isLoaded: destinations.isLoaded, category: SearchCategoryTypes.DESTINATIONS })),
            type: SearchCategoryTypes.DESTINATIONS,
        },
        {
            entityId: 7,
            tabContent: (React.createElement(ContentGridWrapper, { ...commonContentProps, contentItems: other.docs, numFound: other.numFound, isLoaded: other.isLoaded, category: SearchCategoryTypes.OTHER })),
            type: SearchCategoryTypes.OTHER,
        },
    ];
    const mergedTabsData = mergeTabsData(tabsData, primaryFacets, parsedCategoryType);
    return {
        tabsData: mergedTabsData,
    };
};
